// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"198a896c","827":"e0beb441"}[chunkId] + ".chunk.js";
};